/*
 * This constant lives in its own file (rather than alongside
 * FeatureFlagProvider) because Playwright e2e helpers import it to build mock
 * /feature-flags responses. Playwright runs the helper as plain Node ESM and
 * doesn't resolve Next.js's extension-less / non-standard imports, so anything
 * imported from FeatureFlagProvider.tsx transitively pulls in next/router (via
 * AuthProvider et al.) and fails to load. Keeping the defaults in a leaf module
 * with no app-side imports avoids that resolution chain — modify with care.
 */
import type { Success } from "@memento/app/endpoints/feature-flag/list";

export const offlineFeatureFlags: Success = {
  featureFlags: {
    v3Renderer: true,
    sharedAlbumsUpgrade: true,
    groupVideosPaywallMovedToRender: true,
    mixPanelSessionRecording: true,
    customSegmentUploader: true,
  },
  featureConfig: {
    freeTier: {
      numManageClips: 3,
    },
    subscription: {
      trialPeriodDays: {
        // We default to 0 in offline mode because, if these values don't match
        // the server values, it's better for a user to not expect a free trial
        // and later find out there is one instead of expecting a free trial and
        // later finding out there isn't one.
        groupVideos: 0,
        sharedAlbums: 0,
      },
    },
    region: {
      geographic: "us-east",
    },
    render: {
      v2: {
        minSegmentCountToRender: 2,
      },
      v3: {
        minSegmentCountToRender: 1,
        maxSegmentCountToRender: 500,
      },
    },
  },
};
